<template>
    <b-modal
        v-if="$authUser.isAdmin()"
        :id="'create-child-group-modal'"
        :title="$t('group.internship.add_subproject')"
        :ok-title="$t('common.save')"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        modal-class="apprentice-default-modal"
        @ok="onOk($event)">
        <b-form-group
            :label="$t('common.name')"
            label-for="child-group-name">
            <b-form-input
                id="child-group-name"
                v-model="name"
                required
                :placeholder="$t('group.internship.fill_the_name_in_here')"></b-form-input>
        </b-form-group>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-create-child-project-modal-component',
    props: ['groupIn'],
    data() {
        return {
            name: '',
        };
    },
    methods: {
        onOk() {
            this.alert.saving();
            let formData = new FormData();
            formData.append('name', this.name);
            formData.append('parent', this.groupIn.id);

            this.axios.post(this.routes.group(), formData).then(
                (response) => {
                    this.alert.success();
                    window.location.href = this.routes.groupShow(response.data.id);
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped></style>
